var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileAddTeacher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 5.9375V9.3125M17.75 9.3125V12.6875M17.75 9.3125H21.125M17.75 9.3125H14.375M11.8438 4.67188C11.8437 5.67887 11.4437 6.64462 10.7317 7.35667C10.0196 8.06872 9.05387 8.46875 8.04688 8.46875C7.03988 8.46875 6.07413 8.06872 5.36208 7.35667C4.65003 6.64462 4.25 5.67887 4.25 4.67188C4.25 3.66488 4.65003 2.69913 5.36208 1.98708C6.07413 1.27503 7.03988 0.875 8.04688 0.875C9.05387 0.875 10.0196 1.27503 10.7317 1.98708C11.4437 2.69913 11.8438 3.66488 11.8438 4.67188ZM0.875 19.1394V19.0156C0.875 17.1135 1.63061 15.2893 2.97559 13.9443C4.32058 12.5994 6.14478 11.8438 8.04688 11.8438C9.94897 11.8438 11.7732 12.5994 13.1182 13.9443C14.4631 15.2893 15.2187 17.1135 15.2188 19.0156V19.1382C13.0537 20.4422 10.5732 21.1293 8.04575 21.125C5.42337 21.125 2.96975 20.3994 0.875 19.1382V19.1394Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAddTeacher);
export default __webpack_public_path__ + "static/media/MobileAddTeacher.678a77cb5af89b2e46f7ab76e35a5b6e.svg";
export { ForwardRef as ReactComponent };